import loadGoogleMapsApi from 'load-google-maps-api';

function formatMarkerContent(placeData, placeType): string {

  let placeInformationContainer = '<div class="pointOfInterestInfo-container">';

  if (placeData.mapImage) {
    placeInformationContainer += `<img src='${placeData.mapImage}' class='pointOfInterestInfo-img'>`;
  }
  let placeInfo = '<div class="pointOfInterestInfo-wrapper">';
  placeInfo += `<h2 class="pointOfInterestInfo-title">${placeData.title}</h2>`;
  if (placeData.strapline) { placeInfo += `<p class="pointOfInterestInfo-strapline">${placeData.strapline}</p>`;}
  for (const [key, value] of Object.entries(placeData.attributes)) {
    placeInfo += `<p class="pointOfInterestInfo-attribute">${key}: <span>${value}</span></p>`;
  }
  placeInfo += `<a href='${placeData.url}' ${placeData.openNewTab && "target='_blank'"} class="pointOfInterestInfo-link">${placeData.viewButton}</a>`;
  placeInformationContainer += placeInfo;
  placeInformationContainer += '</div>';

  return placeInformationContainer;
}
class Map {
  googleMaps = null;

  map = null;

  previousWindow: any = false;

  key = 'AIzaSyCdlkrru2ofKjgTYPgyL7Mhgd6--0Ka8ok';

  loadGoogleMaps(): Promise<any> {
    return loadGoogleMapsApi({ key: this.key });
  }

  createMap = (
    googleMaps, mapElement: HTMLElement, placeObject: Record<string, any>,
  ) => {
    this.googleMaps = googleMaps;
    this.map = new googleMaps.Map(mapElement, placeObject);
    return this.map;
  }

  addMarker = (lat: number, lng: number, title: string) => {
    const marker = new this.googleMaps.Marker({
      position: this.position(lat, lng),
      title,
    });
    marker.setMap(this.map);
    return marker;
  }

  addLinkMarker = (place, placeType) => {
    const {
      latitude, longitude, title, url, markerIcon,
    } = place;

    const markerContent = formatMarkerContent(place, placeType);

    const infowindow = new this.googleMaps.InfoWindow({
      content: markerContent,
    });

    const marker = new this.googleMaps.Marker({
      icon: markerIcon,
      position: this.position(latitude, longitude),
      title,
      url,
    });

    marker.setMap(this.map);

    this.googleMaps.event.addListener(marker, 'click', () => {
      if (this.previousWindow) {
        this.previousWindow.close();
      }

      this.previousWindow = infowindow;
      infowindow.open(this.googleMaps, marker);
    });

    return marker;
  }

  position = (lat: number, lng: number) => (
    new this.googleMaps.LatLng(lat, lng)
  )
}

export default Map;
